module.exports = __webpack_public_path__ + "static/img/list-wispNesalMask.fdb14ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/list-wispNesalMask.png
// module id = wzJJ
// module chunks = 1